import { ModelIcon as ModelBrandIcon } from '../ModelIcon';
import { useProject } from '../../context/ProjectContext';
import { FilterChip, FilterMenuItem, ModelIcon as GenericModelIcon } from './FilterChip';

export function ModelFilter() {
  const { models, modelFilterId, setModelFilterId } = useProject();

  const selected = models.find((m) => m.id === modelFilterId);
  const label = selected?.publicName ?? 'همه مدل‌ها';
  const isActive = modelFilterId != null;

  if (!models.length) return null;

  const chipIcon = selected ? (
    <ModelBrandIcon svg={selected.iconSvg} name={selected.publicName} size={14} />
  ) : (
    <GenericModelIcon />
  );

  return (
    <FilterChip icon={chipIcon} label={label} active={isActive} align="end">
      <FilterMenuItem selected={!modelFilterId} onClick={() => setModelFilterId(null)}>
        همه مدل‌ها
      </FilterMenuItem>
      {models.map((model) => (
        <FilterMenuItem
          key={model.id}
          selected={modelFilterId === model.id}
          onClick={() => setModelFilterId(model.id)}
          leading={<ModelBrandIcon svg={model.iconSvg} name={model.publicName} size={18} />}
        >
          {model.publicName}
        </FilterMenuItem>
      ))}
    </FilterChip>
  );
}
